import { render, staticRenderFns } from "./ChatAutomatedMind.vue?vue&type=template&id=1fdb4eaa&scoped=true"
import script from "./ChatAutomatedMind.vue?vue&type=script&lang=js"
export * from "./ChatAutomatedMind.vue?vue&type=script&lang=js"
import style0 from "./ChatAutomatedMind.vue?vue&type=style&index=0&id=1fdb4eaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdb4eaa",
  null
  
)

export default component.exports